module.exports = __webpack_public_path__ + "static/media/event_management.10c876cb.png";